import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-8" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "col-8 col-md-6 text-center unavailable mx-auto flex flex-col" }
const _hoisted_4 = { class: "w-full py-2 md:py-8" }
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "my-4 justify-content-center flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-2 flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Konfigurator trenutno ni na voljo")), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("Konfigurator tlakovcev je začasno nedosegljiv.")), 1),
        _hoisted_6,
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t("Želite izvedeti več o Oblak tlakovcih?")), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Vabimo vas da obiščete našo spletno stran, kjer nas lahko kontaktirate.")), 1),
        _createVNode(_component_a_button, {
          type: "primary",
          size: "large",
          shape: "round",
          class: "mt-8 mx-auto",
          href: "https://oblak.si/"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Naprej na spletno stran")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}